/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-12-28 15:29:06
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2023-01-04 10:25:01
 * @FilePath: \ioc_base\src\modules\firePatrol\config\tables.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import i18n from "@src/common/lib/i18n";
import { Dic } from "$utils";
const tableOption = function () {
  return {
    add: "新增",
    edit: "修改",
    view: "详情",
    stripe: true,
    page: true,
    maxHeight: "100%",
    align: "center",
    header: false,
    selection: false,
    emptyText: i18n.t("cameraList.title.noData"),
    delBtn: false,
    editBtn: false,
    menu: false,
    column: [
      {
        label: "巡查名称",
        prop: "firePatrolName",
        clearable: true,
        search: true
      },
      {
        label: "描述",
        prop: "desc"
      },
      {
        label: "状态",
        prop: "status",
        formatter: function (row, value) {
          return Dic.findByValue("SENU11102", value);
        }
      },
      {
        label: "二维码",
        prop: "firePatrolCode",
      }
    ]
  };
};

export default tableOption;
